import { IIcon } from '../interfaces'

const SvgComponent = ({ width = 20, height = 20, size, ...props }: IIcon) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 25 25'
    width={size || width}
    height={size || height}
    {...props}
  >
    <path
      fill='currentColor'
      d='M12.588 19.638q-2.289 0-3.894-1.606-1.606-1.606-1.606-3.894h1.5q0 1.65 1.175 2.825t2.825 1.175 2.825-1.175 1.175-2.825h1.5q0 2.287-1.606 3.894-1.605 1.605-3.894 1.606m0-4.516-3.654-3.654L9.988 10.4l1.85 1.85V5.734h1.5v6.515l1.85-1.85 1.054 1.07z'
    />
  </svg>
)
export default SvgComponent
